import { useOpenAdminPanel as useOpenAdminPanelBase } from "@babackapp/private-api-client/client/use-open-admin-panel";
import { toast } from "@babackapp/ui/components/sonner";

export { adminPanelPath } from "@babackapp/private-api-client/client/use-open-admin-panel";

/** Opens a page of the admin panel in a new tab (super admins; see the shared hook). */
export const useOpenAdminPanel = () =>
  useOpenAdminPanelBase((message) => toast.error(message));
